import { render, staticRenderFns } from "./PlaceBaseAddressField.vue?vue&type=template&id=3053ebfb&scoped=true"
import script from "./PlaceBaseAddressField.vue?vue&type=script&lang=js"
export * from "./PlaceBaseAddressField.vue?vue&type=script&lang=js"
import style0 from "./PlaceBaseAddressField.vue?vue&type=style&index=0&id=3053ebfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053ebfb",
  null
  
)

export default component.exports